import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6947028d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bt-mask-layer" }
const _hoisted_2 = {
  key: 0,
  class: "qh-icon-more"
}
const _hoisted_3 = {
  key: 0,
  class: "invalid-notice"
}
const _hoisted_4 = {
  key: 1,
  class: "bt-loading"
}
const _hoisted_5 = {
  key: 2,
  class: "file-frame"
}
const _hoisted_6 = {
  key: 0,
  class: "file-frame__main"
}
const _hoisted_7 = {
  key: 1,
  class: "file-frame__main file-frame-body"
}
const _hoisted_8 = {
  key: 2,
  class: "file-frame__ul"
}
const _hoisted_9 = { class: "file-frame__options" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = ["checked"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-frame__head" }, [
  /*#__PURE__*/_createElementVNode("span", null, "文件名称"),
  /*#__PURE__*/_createElementVNode("span", null, "类型"),
  /*#__PURE__*/_createElementVNode("span", null, "大小")
], -1))
const _hoisted_13 = {
  key: 1,
  class: "file-frame__empty"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-frame__empty-img" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "任务已全部添加", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconClose = _resolveComponent("IconClose")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_FileInfo = _resolveComponent("FileInfo")!
  const _component_VirtualList = _resolveComponent("VirtualList")!
  const _component_DownloadPath = _resolveComponent("DownloadPath")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref: "footerFrame",
      class: "footer-frame",
      onClick: _cache[11] || (_cache[11] = _withModifiers(() => null, ["stop"])),
      style: _normalizeStyle(_ctx.footerFrameStyle)
    }, [
      _createElementVNode("div", {
        class: "navigation-frame",
        onClick: _cache[2] || (_cache[2] = e => _ctx.$emit('on-floatup'))
      }, [
        _createElementVNode("div", {
          class: "path-frame",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getUpperPath && _ctx.getUpperPath(...args)))
        }, [
          (_ctx.back && _ctx.isLargeViewPort)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.back && _ctx.isLargeViewPort ? '返回' : '新建链接任务'), 1)
        ]),
        (_ctx.isLargeViewPort)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "icomoon-close close-frame",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)))
            }))
          : (_openBlock(), _createBlock(_component_IconClose, {
              key: 1,
              width: "20",
              height: "20",
              href: "javascript:;",
              class: "close-frame",
              onClick: _ctx.handleClose
            }, null, 8, ["onClick"]))
      ]),
      (_ctx.retreat.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 已添加" + _toDisplayString(_ctx.linkStatus.ok) + "个链接，并过滤" + _toDisplayString(_ctx.linkStatus.invalid) + "个无效链接、" + _toDisplayString(_ctx.linkStatus.err) + "个解析失败链接 ", 1))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Loading)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.showIndexTree)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_FileInfo, {
                    file: _ctx.retreat[_ctx.treeIndex],
                    check: false,
                    "is-head": ""
                  }, null, 8, ["file"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.showIndexTree)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.retreat, (tree, index) => {
                    return (_openBlock(), _createBlock(_component_FileInfo, {
                      key: index,
                      file: tree,
                      index: index,
                      check: true,
                      onUpdate: _ctx.handleFile,
                      onGetIn: _ctx.handleTaskTree
                    }, null, 8, ["file", "index", "onUpdate", "onGetIn"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showIndexTree)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'selector-vedio': _ctx.videoIndex.length === 0 || _ctx.videoIndex.length === _ctx.allIndex.length })
                    }, [
                      _createElementVNode("i", {
                        checked: _ctx.chooseAll,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChooseAll && _ctx.handleChooseAll(...args)))
                      }, null, 8, _hoisted_10),
                      _createElementVNode("span", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleChooseAll && _ctx.handleChooseAll(...args)))
                      }, "全选"),
                      _createElementVNode("i", {
                        checked: _ctx.onlyVideo,
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSelectVideo && _ctx.handleSelectVideo(...args)))
                      }, null, 8, _hoisted_11),
                      _createElementVNode("span", {
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSelectVideo && _ctx.handleSelectVideo(...args)))
                      }, "仅视频")
                    ], 2),
                    _createElementVNode("p", null, [
                      (_ctx.back && !_ctx.isLargeViewPort)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("span", {
                              class: "qh-icon-more",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getUpperPath && _ctx.getUpperPath(...args)))
                            }),
                            _createElementVNode("span", {
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getUpperPath && _ctx.getUpperPath(...args))),
                              class: "back"
                            }, "返回")
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.isLargeViewPort ? (
                  `已选${_ctx.chooseIds.length} / ${_ctx.allIndex.length + _ctx.downloadedNums}个文件 共${_ctx.selectedFilesSize}`
                ) : (
                  `${(_ctx.chooseIds.length ? '已选' : '共')}${_ctx.chooseIds.length || (_ctx.allIndex.length + _ctx.downloadedNums)}项`
                )), 1)
                    ])
                  ]),
                  _hoisted_12,
                  (!!_ctx.showTrees.children?.length)
                    ? (_openBlock(), _createBlock(_component_VirtualList, {
                        key: 0,
                        ref: "virtualList",
                        data: _ctx.showTrees.children,
                        "item-size": _ctx.isLargeViewPort ? 36 : 60
                      }, {
                        default: _withCtx(({ item, index }) => [
                          (_openBlock(), _createBlock(_component_FileInfo, {
                            key: item.id,
                            file: item,
                            index: index,
                            onUpdate: _ctx.handleFile,
                            onGetIn: _ctx.handleGetIn,
                            "is-limit-downloaded": _ctx.isLimitDownloaded
                          }, null, 8, ["file", "index", "onUpdate", "onGetIn", "is-limit-downloaded"]))
                        ]),
                        _: 1
                      }, 8, ["data", "item-size"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                ]))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", {
        class: "submit-frame",
        style: _normalizeStyle(_ctx.submitFrameStyle)
      }, [
        _createElementVNode("div", {
          class: "file-upload__select",
          onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleOnToastLimitDownloaded && _ctx.handleOnToastLimitDownloaded(...args)), ["self"]))
        }, [
          _createVNode(_component_DownloadPath, {
            class: "bt-choice-pop-download-path",
            disabled: _ctx.isLimitDownloaded
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", {
          class: "submit-btn",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args))),
          disabled: !_ctx.chooseIds.length
        }, " 立即下载 ", 8, _hoisted_17)
      ], 4)
    ], 4)
  ]))
}